import React from 'react';
import { Image, View, } from 'react-native';
import { BottomBarDLSType, ButtonTypeDLS, ColorTokens, StepperTypeTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import BoilerPlate from "../boilerPlate/BoilerPlate";
import CustomHeader from "../../customHeader/CustomHeader";
import { Typography } from "../../typography/Typography";
import { Stepper } from "../../stepper/Stepper";
import BottomBar from "../../bottomBarDLS/bottomBarDLS";
import ThemeProvider from "@voltmoney/theme";
const RemovePledgeSteps = ({ removePledgeStepperProps, continueAction, triggerAction, goBackAction, needHelpAction, height }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const header = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(CustomHeader, { title: '', triggerAction: triggerAction, goBackAction: goBackAction, needHelpAction: needHelpAction })));
    };
    const footer = () => {
        return (React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_A, btnLoading: false, btnLabel: "Continue to select funds", onPress: () => {
                triggerAction({
                    ...continueAction
                });
            }, isPositionAbsolute: false, btnTypeDLS: ButtonTypeDLS.PRIMARY, labelColor: ColorTokens.White }));
    };
    const bodyView = () => {
        // @ts-ignore
        return (React.createElement(View, null,
            React.createElement(View, { style: { paddingTop: 16, paddingLeft: 16, paddingRight: 16, margin: 16, backgroundColor: 'white', borderRadius: 12 } },
                React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(Image, { source: {
                            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/hour_glass_blue.png',
                        }, style: { width: 48, height: 48 } }),
                    React.createElement(View, { style: { marginLeft: 12, alignItems: 'center', alignSelf: 'center', alignContent: 'center' } },
                        React.createElement(Typography, { label: 'Steps to remove pledge', typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night }))),
                React.createElement(View, { style: {
                        borderStyle: 'dashed',
                        borderWidth: 1,
                        borderRadius: 1,
                        borderColor: '#E4E7EC',
                        marginTop: 16,
                        marginBottom: 20
                    } }),
                React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: removePledgeStepperProps, isProcessing: false }))));
    };
    return (React.createElement(BoilerPlate, { height: height, bottomChildren: React.createElement(React.Fragment, null, footer()), headerChild: React.createElement(React.Fragment, null, header()), backgroundColor: ColorTokens.Primary_05 }, React.createElement(React.Fragment, null, bodyView())));
};
export default RemovePledgeSteps;
